import { BookedTrip } from '@ibe.models/booked-trip.model.lib';
import { PassengersSegmentedCount } from '@ibe/models';
import { Action } from '@ngrx/store';
import { type } from '../util';

export const ActionTypes = {
	LOADING: type('[BookedTrip] loading '),
	PUT_BOOKEDTRIP: type('[BookedTrip] Update'),
	PUT_PREORDER_ELEGIBLE: type('[BookedTrip] PreOrder Eligibility' ),
	PUT_BOOKEDTRIPPASSENGER: type('[BookedTrip] Passenger Update'),
	PUT_BOOKEDTRIP_DISCOUNT: type('[BookedTrip] Discounts Update'),
	PUT_BOOKEDTRIP_INSURANCE: type('[BookedTrip] Insurance Update'),
	PUT_BOOKEDTRIP_EXTRAS: type('[BookedTrip] Extras Update'),
	REMOVE_BOOKEDTRIP_EXTRAS: type('[BookedTrip] Extra Remove'),
	REMOVE_BOOKEDTRIP_EXTRAS_WITH_OPTIONS: type('[BookedTrip] Extra Remove with options'),
	PUT_BOOKEDTRIP_STOPOVER: type('[BookedTrip] Stopover Update'),
	PUT_BOOKEDTRIP_PROMO_VOUCHERS: type('[BookedTrip] Promo and Voucher Update'),
	REMOVE_BOOKEDTRIP_EXTRAS_BY_CITY: type('[BookedTrip] Extra Remove By City'),
	REMOVE_BOOKEDTRIP_EXTRAS_BY_CITY_AND_TYPE: type('[BookedTrip] Extra Remove By City And Type'),
	PUT_WEAKFLIGHT_AMT: type('[BookedTrip] put weakflight amount'),
	PUT_BOOKEDTRIP_TIME_TO_THINK_DETAILS: type('[BookedTrip] put time to think details'),
	RESET: type('[BookedTrip] Reset')
};

export class LoadingAction implements Action {
	type = ActionTypes.LOADING;

	/**
	 *Creates an instance of LoadingAction.
	 * @param {*} [payload]
	 * @memberof LoadingAction
	 */
	constructor(public payload?) { }
}

export class PutBookedTripAction implements Action {
	type = ActionTypes.PUT_BOOKEDTRIP;


	/**
	 *Creates an instance of PutBookedTripAction.
	 * @param {*} payload
	 * @memberof PutBookedTripAction
	 */
	constructor(public payload: BookedTrip) { }
}

export class PutBookedTripPassengerAction implements Action {
	type = ActionTypes.PUT_BOOKEDTRIPPASSENGER;


	/**
	 *Creates an instance of PutBookedTripAction.
	 * @param {*} payload
	 * @memberof PutBookedTripPassengerAction
	 */
	constructor(public payload: PassengersSegmentedCount) { }
}

export class PutBookedTripDiscountsAction implements Action {
	type = ActionTypes.PUT_BOOKEDTRIP_DISCOUNT;


	/**
	 *Creates an instance of PutBookedTripDiscountsAction.
	 * @param {*} payload
	 * @memberof PutBookedTripDiscountsAction
	 */
	constructor(public payload: Array<{ value: number, id: string, label: string }>) { }
}

export class PutBookedTripInsuranceAction implements Action {
	type = ActionTypes.PUT_BOOKEDTRIP_INSURANCE;


	/**
	 *Creates an instance of PutBookedTripInsuranceAction.
	 * @param {*} payload
	 * @memberof PutBookedTripInsuranceAction
	 */
	constructor(public payload: Array<{ name: string, value: string, price: number }>) { }
}

export class PutBookedTripExtrasAction implements Action {
	type = ActionTypes.PUT_BOOKEDTRIP_EXTRAS;

	/**
	 *Creates an instance of PutBookedTripExtrasAction.
	 * @param {*} payload
	 * @memberof PutBookedTripExtrasAction
	 */
	constructor(public payload: { stopoverCity?: string, type: string, value?: Object, data?: Object, stopoverHotel?: boolean, selectedExtra?: Object}) { }
}

export class RemoveBookedTripExtraAction implements Action {
	type = ActionTypes.REMOVE_BOOKEDTRIP_EXTRAS;

	/**
	 * Creates an instance of RemoveBookedTripExtraAction
	 * @param {string} payload
	 * @param {any} data
	 * @memberof RemoveBookedTripExtraAction
	 */
	constructor(public payload: any) { }
}


export class RemoveBookedTripExtraActionWithOptions implements Action {
	type = ActionTypes.REMOVE_BOOKEDTRIP_EXTRAS_WITH_OPTIONS;

	/**
	 * Creates an instance of RemoveBookedTripExtraActionWithOptions
	 * @param {string} payload
	 * @memberof RemoveBookedTripExtraActionWithOptions
	 */
	constructor(public payload: any) { }
}

export class PutBookedTripStopoverAction implements Action {
	type = ActionTypes.PUT_BOOKEDTRIP_STOPOVER;

	/**
	 *Creates an instance of PutBookedTripStopoverAction.
	 * @param {*} payload
	 * @memberof PutBookedTripStopoverAction
	 */
	constructor(public payload: any ) { }
}

export class PutBookedTripPromoVouchersAction implements Action {
	type = ActionTypes.PUT_BOOKEDTRIP_PROMO_VOUCHERS;


	/**
	 *Creates an instance of PutBookedTripPromoVouchersAction.
	 * @param {*} payload
	 * @memberof PutBookedTripPromoVouchersAction
	 */
	constructor(public payload: any) { }
}

export class RemoveBookedTripExtraByCityAction implements Action {
	type = ActionTypes.REMOVE_BOOKEDTRIP_EXTRAS_BY_CITY;

	/**
	 * Creates an instance of RemoveBookedTripExtraByCityAction
	 * @param {string} payload
	 * @memberof RemoveBookedTripExtraByCityAction
	 */
	constructor(public payload: any) { }
}

export class RemoveBookedTripExtraByCityAndTypeAction implements Action {
	type = ActionTypes.REMOVE_BOOKEDTRIP_EXTRAS_BY_CITY_AND_TYPE;

	/**
	 * Creates an instance of RemoveBookedTripExtraByCityAction
	 * @param {string} payload
	 * @memberof RemoveBookedTripExtraByCityAndTypeAction
	 */
	constructor(public payload: {stopoverCity: string, type: string}) { }
}

export class PutWeakFlightAmount implements Action {
	type = ActionTypes.PUT_WEAKFLIGHT_AMT;

	/**
	 *Creates an instance of PutWeakFlightAmount.
	 * @param {*} payload
	 * @memberof PutWeakFlightAmount
	 */
	constructor(public payload: any) { }
}

export class PutBookedTripTimeToThinkDetails implements Action {
	type = ActionTypes.PUT_BOOKEDTRIP_TIME_TO_THINK_DETAILS;

	/**
	 *Creates an instance of PutBookedTripTimeToThinkDetails.
	 * @param {*} payload
	 * @memberof PutBookedTripTimeToThinkDetails
	 */
	constructor(public payload: any) { }
}

export class ResetAction implements Action {
	type = ActionTypes.RESET;

	constructor(public payload?) { }
}

export class PreOrderEligibleAction implements Action {
	type = ActionTypes.PUT_PREORDER_ELEGIBLE;

	constructor(public payload?) { }
}

export type Actions = LoadingAction | PutBookedTripAction | ResetAction | PutBookedTripPassengerAction | PutBookedTripDiscountsAction | PutBookedTripInsuranceAction | PutBookedTripExtrasAction | RemoveBookedTripExtraAction | PreOrderEligibleAction | PutBookedTripStopoverAction | PutBookedTripPromoVouchersAction | RemoveBookedTripExtraByCityAction | RemoveBookedTripExtraByCityAndTypeAction | RemoveBookedTripExtraActionWithOptions | PutWeakFlightAmount | PutBookedTripTimeToThinkDetails;
